import { useState, useEffect } from 'react';

/**
 * Hook to detect and monitor online/offline status
 * @returns {boolean} isOnline - Whether the browser is online
 */
export const useOnlineStatus = (): boolean => {
  const [isOnline, setIsOnline] = useState<boolean>(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );

  useEffect(() => {
    // Update network status
    const handleOnline = () => {
      setIsOnline(true);
      console.log('🟢 Network: Online');
    };

    const handleOffline = () => {
      setIsOnline(false);
      console.log('🔴 Network: Offline');
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Check initial status
    setIsOnline(navigator.onLine);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
};
